var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgG = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "5.25rem",
  height: "5.25rem",
  "data-name": "Group 16",
  viewBox: "0 0 199.72 187.676"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "G_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h199.72v187.676H0z",
  "data-name": "Rectangle 22"
})))), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 15",
  style: {
    clipPath: "url(#G_svg__a)"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M90.859 5.388 1.225 172.64a10.212 10.212 0 0 0 9 15.036h179.269a10.213 10.213 0 0 0 9-15.036L108.861 5.388a10.212 10.212 0 0 0-18 0",
  "data-name": "Path 8"
}))));
export default SvgG;